module.exports = __webpack_public_path__ + "img/1fie-m-niseye'.7359ff8e.jpg";